import axios from 'axios';
import { DafScopeConfig, DafAuthError, DafGrantType, DafAuthResponse } from '../types';
import { stringifyScopes } from './stringifyScopes';
import { dafErrorMap } from './dafErrorMap';

export enum DafTokenExchangeError {
    INVALID_SEED_TOKEN = 'INVALID_SEED_TOKEN'
}

export const DAF_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:access_token';
export const DAF_SUBJECT_TOKEN_TYPE = 'nab:oauth:token-type:client_id';

function createRequestPayload(seedTokenValue: string, scopeConfig: DafScopeConfig) {
    return {
        client_id: scopeConfig.clientId,
        grant_type: DafGrantType.tokenExchange,
        requested_token_type: DAF_TOKEN_TYPE,
        subject_token: scopeConfig.clientId,
        subject_token_type: DAF_SUBJECT_TOKEN_TYPE,
        actor_token: seedTokenValue,
        actor_token_type: DAF_TOKEN_TYPE,
        scope: stringifyScopes(scopeConfig.scopes)
    };
}

export async function exchangeDafToken(seedTokenValue: string, scopeConfig: DafScopeConfig, endpoint: string): Promise<DafAuthResponse> {
    const payload = createRequestPayload(seedTokenValue, scopeConfig);

    try {
        const response = await axios.post<DafAuthResponse>(endpoint, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (e) {
        if (e && e.response && e.response.status) {
            if (e.response.status === 401) {
                throw new Error(DafTokenExchangeError.INVALID_SEED_TOKEN);
            } else if (dafErrorMap[`${e.response.status}`]) {
                throw new Error(dafErrorMap[`${e.response.status}`]);
            } else {
                throw new Error(DafAuthError.UNKNOWN_ERROR);
            }
        } else {
            throw new Error(DafAuthError.UNKNOWN_ERROR);
        }
    }
}
